// 頭像選項配置
// 圖片應放置在 public/avatars/ 資料夾中
export const avatarOptions = [
  { id: 'avatar1', url: '/avatars/avatar1.png', name: '頭像1' },
  { id: 'avatar2', url: '/avatars/avatar2.png', name: '頭像2' },
  { id: 'avatar3', url: '/avatars/avatar3.png', name: '頭像3' },
  { id: 'avatar4', url: '/avatars/avatar4.png', name: '頭像4' },
  { id: 'avatar5', url: '/avatars/avatar5.png', name: '頭像5' },
  { id: 'avatar6', url: '/avatars/avatar6.png', name: '頭像6' },
  { id: 'avatar7', url: '/avatars/avatar7.png', name: '頭像7' },
  { id: 'avatar8', url: '/avatars/avatar8.png', name: '頭像8' },
  { id: 'avatar9', url: '/avatars/avatar9.png', name: '頭像9' },
  { id: 'avatar10', url: '/avatars/avatar10.png', name: '頭像10' },
  { id: 'avatar11', url: '/avatars/avatar11.png', name: '頭像11' },
  { id: 'avatar12', url: '/avatars/avatar12.png', name: '頭像12' },
  { id: 'avatar13', url: '/avatars/avatar13.png', name: '頭像13' },
  { id: 'avatar14', url: '/avatars/avatar14.png', name: '頭像14' },
  { id: 'avatar15', url: '/avatars/avatar15.png', name: '頭像15' },
  { id: 'avatar16', url: '/avatars/avatar16.png', name: '頭像16' },
  { id: 'avatar17', url: '/avatars/avatar17.png', name: '頭像17' },
  { id: 'avatar18', url: '/avatars/avatar18.png', name: '頭像18' },
  { id: 'avatar19', url: '/avatars/avatar19.png', name: '頭像19' },
  { id: 'avatar20', url: '/avatars/avatar20.png', name: '頭像20' },
  { id: 'avatar21', url: '/avatars/avatar21.png', name: '頭像21' },
  { id: 'avatar22', url: '/avatars/avatar22.png', name: '頭像22' },
  { id: 'avatar23', url: '/avatars/avatar23.png', name: '頭像23' },
  { id: 'avatar24', url: '/avatars/avatar24.png', name: '頭像24' },
  { id: 'avatar25', url: '/avatars/avatar25.png', name: '頭像25' },
  { id: 'avatar26', url: '/avatars/avatar26.png', name: '頭像26' },
  { id: 'avatar27', url: '/avatars/avatar27.png', name: '頭像27' },
  { id: 'avatar28', url: '/avatars/avatar28.png', name: '頭像28' },
  { id: 'avatar29', url: '/avatars/avatar29.png', name: '頭像29' },
  { id: 'avatar30', url: '/avatars/avatar30.png', name: '頭像30' },
  { id: 'avatar31', url: '/avatars/avatar31.png', name: '頭像31' },
  { id: 'avatar32', url: '/avatars/avatar32.png', name: '頭像32' }
];

// 根據 avatarId 獲取頭像信息
export const getAvatarById = (avatarId) => {
  return avatarOptions.find(avatar => avatar.id === avatarId) || avatarOptions[0];
};

// 檢查是否為圖片 URL
const isImageUrl = (avatar) => {
  if (!avatar) return false;
  // Check if it's a URL (starts with http:// or https://)
  return avatar.startsWith('http://') || avatar.startsWith('https://');
};

// 頭像顯示組件
export const AvatarDisplay = ({ avatarId, size = 32, showName = false, style = {} }) => {
  // Check if avatarId is an image URL (starts with http or data:image for base64)
  const isCustomImage = isImageUrl(avatarId) || (avatarId && avatarId.startsWith('data:image'));
  const avatar = isCustomImage ? null : getAvatarById(avatarId);

  const avatarStyle = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid #eef4f9',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    objectFit: 'cover',
    ...style
  };

  // 外部圖片（如 Google OAuth 大頭貼）可能過期或被擋盜連，載入失敗時退回預設頭像
  const handleImageError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = avatarOptions[0].url;
  };

  // Render custom uploaded image (base64 or external URL)
  if (isCustomImage) {
    if (showName) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src={avatarId}
            alt="User avatar"
            style={avatarStyle}
            onError={handleImageError}
          />
          <span style={{ fontSize: '14px', color: '#6b7280' }}>
            自訂頭像
          </span>
        </div>
      );
    }

    return (
      <img
        src={avatarId}
        alt="User avatar"
        style={avatarStyle}
        title="自訂頭像"
        onError={handleImageError}
      />
    );
  }

  // Render preset avatar image
  if (showName) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img
          src={avatar.url}
          alt={avatar.name}
          style={avatarStyle}
        />
        <span style={{ fontSize: '14px', color: '#6b7280' }}>
          {avatar.name}
        </span>
      </div>
    );
  }

  return (
    <img
      src={avatar.url}
      alt={avatar.name}
      style={avatarStyle}
      title={avatar.name}
    />
  );
};

const avatarUtils = { avatarOptions, getAvatarById, AvatarDisplay };
export default avatarUtils;